
import * as React from "react";

import {
    List,
    EmailField,
  
    TopToolbar,
    EditButton,
    
    ExportButton,
    ShowButton,
   
    TextInput,
   
    Datagrid,
   
    TextField,
   
    FilterButton,
    SearchInput,
   
} from "react-admin";




const ListActions = (props) => (
    <TopToolbar>
        <FilterButton />
        <ExportButton />
    </TopToolbar>
);

const UserFilters = [<SearchInput  source="user_name" alwaysOn />, <TextInput label="Store Name" source="store_name" />];


export const UserList = (props) => (
    <List {...props} filters={UserFilters} actions={<ListActions />}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="user_name" />
            <EmailField source="email" />
            <TextField source="store_name" />
            <ShowButton />
            <EditButton />
        </Datagrid>
    </List>
);